// extracted by mini-css-extract-plugin
export default {"root":"CartDetails_root__Bb6p5","cartTotal":"CartDetails_cartTotal__SUDlv","cards":"CartDetails_cards__A0CN7","priceHead":"CartDetails_priceHead__y64wy"};